var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('f-page-header',{attrs:{"title":_vm.title,"prevLinks":_vm.prevLinks}}),(_vm.isLoading)?_c('lms-default-loader'):_vm._e(),(!_vm.isLoading)?_c('f-container',{attrs:{"topBottom":""}},[_c('f-form')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }